import { ThemeProvider, useMediaQuery, CssBaseline } from '@mui/material';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './components/Layout';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SnackbarProvider } from 'notistack';
import { TourProvider } from './contexts/TourContext';
import createAppTheme from './theme';

export default function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const theme = React.useMemo(
    () => createAppTheme(prefersDarkMode ? 'dark' : 'light'),
    [prefersDarkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
      >
        <TourProvider>
          <Router>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Layout />
            </LocalizationProvider>
          </Router>
        </TourProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
